import React, { Component } from "react";
import { connect } from "react-redux";
import Input from "../../../../shared/Input/Input";
import Select from "./../../../../shared/Select/Select";
import { getBanks, hasBank, sendCreateUpdateBank, getUserBank } from "../../../shared/requests-api";
import {
	isAllFieldsEmpty,
	returnUserJWT,
	getUserToken,
	scrollToComponent
} from "../../../shared/utils";
import Modal from "../../../../shared/Modal/Modal";
import Button from "../../../../shared/button/button";
import Loading from "../../../../shared/Loading/Loading";
import { ROUTE_HOME } from "../../../shared/constants";
import { isMobile } from "../../../../../js/components/searchform/utils/common";

class AccountBankDetails extends Component {
	constructor() {
		super();
		this.state = {
			banks: [],
			errors: {}
		};

		this.save = this.save.bind(this);
		this.validForm = this.validForm.bind(this);
		this.selectBankOption = this.selectBankOption.bind(this);
		this.confirmSave = this.confirmSave.bind(this);
		this.handleBank = this.handleBank.bind(this);
	}

	componentDidMount() {
		window.scrollTo(0, 0);
		const { banks } = this.props;

		if (!banks) {
			this.setState({ loading: true });
		}

		this.handleBank(this.props);
	}

	componentWillReceiveProps(nextProps) {
		this.handleBank(nextProps);
	}

	componentWillUnmount() {
		this._unmounted = true;
	}

	handleBank(props) {
		const self = this;
		const { banks } = props;
		const { bankId } = this.state;

		const user = returnUserJWT();
		if (user) {
			this.setState({ cpfcnpj: user.ssn });
		}

		if (banks && !bankId) {
			let banksMap = banks.map(bank => {
				return { value: bank.idBank, label: bank.name };
			});

			this.setState({ loading: true });
			getUserBank(getUserToken())
				.then(response => {
					if (this._unmounted) return;
					const { bankId, agency, dacAgency, type, account, dacAccount, cpfcnpj } = response.data;

					let bankOption = banksMap.find(bank => bank.value == bankId);
					let errors = self.state;

					errors.agency = "";
					errors.dacAgency = dacAgency ? "" : undefined;
					errors.account = "";
					errors.dacAccount = "";
					errors.bankOption = "";

					self.setState({
						bankId,
						bank: bankId,
						bankOption,
						agency,
						type: 'c',
						dacAgency,
						account,
						dacAccount,
						//cpfcnpj,
						errors,
						loading: false
					});
				})
				.catch(res => {
					self.setState({ loading: false, errors: {} });
				});

			self.setState({
				banks: banksMap
			});
		}
	}

	confirmSave() {
		const {
			bankOption,
			agency,
			bank,
			account,
			cpfcnpj,
			errors,
			dacAccount,
			dacAgency
		} = this.state;
		if (!this.isValid()) {
			if (cpfcnpj == "" || cpfcnpj == undefined) {
				errors.cpfcnpj = "Campo obrigatório";
			}
			if (dacAccount == "" || dacAccount == undefined) {
				errors.dacAccount = "Campo obrigatório";
			}
			if (account == "" || account == undefined) {
				errors.account = "Campo obrigatório";
			}
			if (agency == "" || agency == undefined) {
				errors.agency = "Campo obrigatório";
			}
			if (!bankOption) {
				errors.bankOption = "Campo obrigatório";
			}
			if (bank == 45) {
				if (dacAgency == "" || dacAgency == undefined) {
					errors.dacAgency = "Campo obrigatório";
				}
			}
			this.setState({ errors });
		} else {
			this.save();
		}
	}

	save = () => {
		const token = getUserToken();
		const { bankOption, agency, dacAgency, account, dacAccount, cpfcnpj } = this.state;
		let self = this;

		self.setState({ sending: true });
		sendCreateUpdateBank(token, bankOption.value, agency, dacAgency, account, dacAccount, cpfcnpj)
			.then(response => {
				self.setState({ sending: false, showSucesso: true });
			})
			.catch(response => {
				self.setState({ sending: false, showSucesso: false });
			});
	};

	selectBankOption(bankOption) {
		const { errors, bank } = this.state;
		errors.bankOption = "";
		this.setState({ bankOption, bank: bankOption.value, errors });

		if (bank && bank !== bankOption.value) {
			bank == 45
				? this.setState({ agency: "", dacAgency: "", account: "", dacAccount: "" })
				: this.setState({ agency: "", account: "", dacAccount: "" });
		}
	}

	validForm(event) {
		const { errors } = this.state;
		let value = event.target.type == "checkbox" ? event.target.checked : event.target.value;

		if (event.target.name == "account") {
			value = value.replace(/\D/g, "");
		}

		if (event.target.name == "agency") {
			value = value.replace(/\D/g, "");
			this.moveOnMax(event, "dacAgencyId");
		}

		if (event.target.name == "dacAccount") {
			value = value.replace(/[^0-9xX]/g, "");
		}

		if (event.target.name == "dacAgency") {
			value = value.replace(/[^0-9xX]/g, "");
		}

		errors[event.target.name] = value
			? ""
			: `${event.target.title || event.target.name} não confere`;

		this.setState({ [event.target.name]: value, errors });
	}

	isValid = () => {
		const { agency, bank, bankOption, account, dacAccount, dacAgency, errors } = this.state;

		let valid =
			agency &&
			bankOption &&
			dacAccount &&
			account &&
			isAllFieldsEmpty(errors, "agency", "dacAccount", "account");

		if (bank == 45 && valid) {
			valid = dacAgency && isAllFieldsEmpty(errors, "dacAgency");
		}

		return valid;
	};

	moveOnMax(event, nextFieldID) {
		const { bank } = this.state;
		if (bank == 45) {
			let value = event.target.value;
			if (value.length >= event.target.maxLength) {
				document.getElementById(nextFieldID).focus();
			}
		}
	}

	render() {
		const {
			loading,
			bankOption,
			banks,
			bankId,
			agency,
			type,
			bank,
			account,
			cpfcnpj,
			errors,
			dacAccount,
			dacAgency,
			sending,
			showSucesso
		} = this.state;

		if (loading) {
			return (
				<div className="panel-content-component">
					<Loading />
				</div>
			);
		}

		return (
			<section className="account-bank-details panel-content-component row no-margin">
				<form className="form-offer block-center" onChange={this.validForm}>
					<div className="col-xs-16 text-center no-padding">
						<p className="account-bank-details--title">
							Precisamos dos seus dados bancários para realizar o pagamento das vendas feitas por
							você na MaxMilhas. <br />
							<strong>Mas, atenção!</strong> O titular da conta bancária deve ser o mesmo titular
							das milhas. Combinado?
						</p>
					</div>
					<div className="row">
						<div className="col-xs-16 col-md-8 form-group">
							<Input
								className="account-bank-details--input--document"
								label="Titular da conta"
								placeholder="XXX.XXX.XXX-XX"
								name="cpfcnpj"
								disabled
								value={cpfcnpj}
								data-action="account-bank-details-cpfcnpj-titular"
							/>
						</div>
						<div
							className="col-xs-16 col-md-8 form-group bank-select"
							onClick={isMobile() && (() => scrollToComponent(".bank-select"))}
						>
							<label className="account-bank-details--label" htmlFor="bank-select">
								Banco*
							</label>
							<Select
								id="bank-select"
								selected={bankOption}
								errorMessage={errors.bankOption}
								onChange={bankOption => this.selectBankOption(bankOption)}
								options={banks}
								name="bank"
								hasSearch={true}
								data-action="account-bank-details-bank-select"
							/>
						</div>
					</div>
					<div className="row">
						<div
							className={`agency-input ${
								bank == 45 ? "col-xs-12 col-md-6 agency" : "col-xs-16 col-md-8"
							} form-group`}
							onClick={isMobile() && (() => scrollToComponent(".agency-input"))}
						>
							<Input
								label="Agência*"
								placeholder="Inserir sua agência"
								name="agency"
								required
								value={agency}
								pattern="\d*"
								inputMode="numeric"
								errorMessage={errors.agency}
								maxLength="4"
								id="agencyId"
								data-action="account-bank-details-agency"
							/>
						</div>
						{bank == 45 && (
							<div
								className="col-xs-4 col-md-2 form-group digit agency-digit"
								onClick={isMobile() && (() => scrollToComponent(".agency-digit"))}
							>
								<Input
									label="Dígito*"
									placeholder="0"
									name="dacAgency"
									maxLength="1"
									required
									value={dacAgency}
									pattern="\d*"
									inputMode="numeric"
									errorMessage={errors.dacAgency}
									id="dacAgencyId"
									data-action="account-bank-details-agency-digit"
								/>
							</div>
						)}

						<div
							className="col-xs-12 col-md-6 form-group account"
							onClick={isMobile() && (() => scrollToComponent(".account"))}
						>
							<Input
								label="Conta corrente*"
								placeholder="Inserir sua conta"
								name="account"
								required
								value={account}
								pattern="\d*"
								inputMode="numeric"
								maxLength="18"
								errorMessage={errors.account}
								data-action="account-bank-details-account"
							/>
						</div>
						<div
							className="col-xs-4 col-md-2 form-group digit account-digit"
							onClick={isMobile() && (() => scrollToComponent(".account-digit"))}
						>
							<Input
								label="Dígito*"
								placeholder="0"
								name="dacAccount"
								maxLength="1"
								required
								value={dacAccount}
								pattern="\d*"
								inputMode="numeric"
								errorMessage={errors.dacAccount}
								data-action="account-bank-details-account-digit"
							/>
						</div>
					</div>

					<div className="row row-botoes">
						<div className="col-xs-16 text-right">
							<Button
								className="btn btn-cancel"
								onClick={() => (window.location.href = ROUTE_HOME)}
								type="button"
								data-action="account-bank-details-cancel"
							>
								Cancelar
							</Button>
							<Button
								className={`btn btn-primary confirm-button ${sending ? "btn-loading" : ""}`}
								onClick={this.confirmSave}
								disabled={sending}
								type="button"
								data-action="account-bank-details-save"
							>
								{sending ? <Loading /> : "Salvar"}
							</Button>
						</div>
					</div>

					<Modal
						title="DADOS ALTERADOS"
						description="Seus dados foram alterados com sucesso :)"
						confirm="Fechar"
						show={showSucesso}
						onCancel={() => this.setState({ showSucesso: false })}
						onConfirm={() => this.setState({ showSucesso: false })}
					/>
				</form>
			</section>
		);
	}
}

const mapStateToProps = state => ({
	banks: state.createOffer.banks
});

export default connect(mapStateToProps)(AccountBankDetails);
